import { render, staticRenderFns } from "./ServiceGroup.vue?vue&type=template&id=04ff1572"
import script from "./ServiceGroup.vue?vue&type=script&lang=js"
export * from "./ServiceGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports